import { LocaleIdentifier } from '@repo/markets/types'
import useSWR, { SWRConfiguration } from 'swr'
import { ShopProduct } from './types'

const fetcher = async <T>(...args: Parameters<typeof fetch>): Promise<T> => {
  const res = await fetch(...args)

  if (!res.ok) {
    throw new Error(`Fetch error: ${res.status} ${res.statusText}`)
  }

  return (await res.json()) as T
}

export const useProducts = ({ locale, urlSlugs, options }: { locale: LocaleIdentifier; urlSlugs: string[]; options?: SWRConfiguration }) => {
  // See ./route.ts for GET endpoint this SWR requests to.
  return useSWR<ShopProduct[]>(urlSlugs.length > 0 ? `/${locale}/api/shop/products?urlSlugs=${urlSlugs.join(',')}` : null, fetcher, options)
}
